import { render, staticRenderFns } from "./SportTemplates.vue?vue&type=template&id=5a8fa628"
import script from "./SportTemplates.vue?vue&type=script&lang=js"
export * from "./SportTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports